<template>
<div class="chapter">
<div class="inner_page">
<p class="normal-1">“The days of visitation are come,</p>
<p class="normal-3">the days of recompence are come;</p>
<p class="normal-3">Israel shall know it: the prophet is</p>
<p class="normal-3">a fool, the spiritual man is mad …”</p>
<p class="right"><span>—Hosea, 9:7</span></p>
<p class="normal-2">“But whereunto shall I liken</p>
<p class="normal-3">this generation? It is like</p>
<p class="normal-3">unto children sitting in the</p>
<p class="normal-3">markets, and calling unto</p>
<p class="normal-3">their fellows,</p>
<p class="normal-3">And saying, We have piped</p>
<p class="normal-3">unto you, and ye have not</p>
<p class="normal-3">danced; we have mourned unto</p>
<p class="normal-3">you, and ye have not lamented.”</p>
<p class="right"><span>—St. Matthew, 11:16, 17</span></p>
<p class="normal-2">“Fathers and teachers, I ponder ‘What is hell?’ I maintain that it is the suffering of being unable to love.”</p>
<p class="right"><span>—Father Zossima</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter01.vue?b6473952